// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"3965d31b","701":"082100d1"}[chunkId] + ".chunk.js";
};